import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css"; // Remove global CSS import
import App from "./App.tsx";

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  // Render your React component
  root.render(<App />);
} else {
  console.error("Root element not found");
}
